<template>
  <billing-report-panel
    report-key="transfer-forecast"
    route="/reports/billing-transfer-forecast"
    file-name="repasse-previsto-e-pago.xlsx"
    period-label="Período da competência"
    :columns="columns"
    :default-days="180"
    show-professional
  />
</template>

<script>
import BillingReportPanel from './BillingReportPanel.vue';

export default {
  components: {
    BillingReportPanel,
  },
  data() {
    return {
      columns: [
        'Profissional',
        'Competência',
        'Situação',
        'Repasse calculado',
        'Já pago',
        'Em aberto',
        'Diferença',
        'Preso em lote não recebido',
        'Liberado para pagamento',
        'Subtotal por profissional',
      ],
    };
  },
};
</script>
